import { DropdownQueryParam } from './queryParams';

export const getLabelFromQueryParam = (
  queryParam: DropdownQueryParam
): string => {
  switch (queryParam) {
    case DropdownQueryParam.ORGANIZATION:
      return 'Organization';
    case DropdownQueryParam.ORIGINATOR_ID:
      return 'Customer';
    case DropdownQueryParam.ORIGINATOR_STATUS:
      return 'Customer Status';
    case DropdownQueryParam.PLACE_ID:
      return 'Place';
    case DropdownQueryParam.USER_ID:
      return 'User';
    case DropdownQueryParam.SUBMITTED:
      return 'Submitted';
    case DropdownQueryParam.PICKUP_LOCATION:
      return 'Pickup';
    case DropdownQueryParam.ORIGIN_PLACE_ID:
      return 'Pickup';
    case DropdownQueryParam.DELIVERY_LOCATION:
      return 'Delivery';
    case DropdownQueryParam.DESTINATION_PLACE_ID:
      return 'Delivery';
    case DropdownQueryParam.JOB_STATUS:
      return 'Job Status';
    case DropdownQueryParam.QUOTE_STATUS:
      return 'Quote Status';
    case DropdownQueryParam.PLACE_TAG:
      return 'Tag';
    case DropdownQueryParam.CREATED_AT_START_DATE:
    case DropdownQueryParam.CREATED_AT_END_DATE:
      return 'Date Created';
    case DropdownQueryParam.LAST_ACTIVE_START_DATE:
    case DropdownQueryParam.LAST_ACTIVE_END_DATE:
      return 'Last Active';
    case DropdownQueryParam.PICKUP_FIRST_DATE:
    case DropdownQueryParam.PICKUP_SECOND_DATE:
      return 'Pickup Date';
    case DropdownQueryParam.DELIVERY_FIRST_DATE:
    case DropdownQueryParam.DELIVERY_SECOND_DATE:
      return 'Delivery Date';
    case DropdownQueryParam.COMPUTATION_TYPE:
      return 'Computation Type';
    case DropdownQueryParam.EXTERNAL_MESSAGE_ID:
      return 'Messages';
    case DropdownQueryParam.EQUIPMENT_TYPE:
      return 'Equipment';
    case DropdownQueryParam.MEMBER_ROLE:
      return 'Role';
    case DropdownQueryParam.FREIGHT_MODE:
      return 'Shipment Type';
    case DropdownQueryParam.AUCTION_TYPE:
      return 'Auction Type';
    case DropdownQueryParam.CONTRACT_TYPE:
      return 'Contract Type';
    case DropdownQueryParam.LABEL_STATUS:
      return 'Label Status';
    case DropdownQueryParam.VOOMA_CONFIRMATION_STATUS:
      return "Vooma's Role";
    case DropdownQueryParam.TEAM_ID:
      return 'Team';
    case DropdownQueryParam.SAVED_CLASSIFICATION:
      return 'Saved Computation Class';
    case DropdownQueryParam.LABELED_CLASSIFICATION:
      return 'Label Class';
    case DropdownQueryParam.SINCE_DAYS_AGO:
      return 'Last';
    case DropdownQueryParam.TO_DAYS_AHEAD:
      return 'Next';
    case DropdownQueryParam.FROM_PHONE_NUMBER:
      return 'From Phone Number';
    case DropdownQueryParam.TO_PHONE_NUMBER:
      return 'To Phone Number';
    case DropdownQueryParam.CONVERSATION_LABELS:
      return 'Label';
    case DropdownQueryParam.LOADBOARD:
      return 'Loadboard';
    case DropdownQueryParam.HAS_CARRIER:
      return 'Has Carrier';
    case DropdownQueryParam.ON_HOLD:
      return 'On Hold';
    case DropdownQueryParam.ACTION_DEFINITION_ID:
      return 'SOP';
    case DropdownQueryParam.CUSTOM_FREIGHT_TAGS:
      return 'Custom Freight Tags';
    case DropdownQueryParam.AUTO_SUBMIT_SCOPE:
      return 'Order Auto-Submit';
    case DropdownQueryParam.QUOTE_AUTO_REPLY_SCOPE:
      return 'Quote Auto-Reply';
    case DropdownQueryParam.THREAD_LENGTH:
      return 'Email Thread Length';
    case DropdownQueryParam.OPTIMISM_STATUS:
      return 'Detection';
    case DropdownQueryParam.TRACKING_TYPE:
      return 'Tracking Type';
    case DropdownQueryParam.SOP_TAG:
      return 'Tag';
    case DropdownQueryParam.TRACK_ENABLED:
      return 'Track';
    case DropdownQueryParam.TRACK_REP:
      return 'Rep';
    case DropdownQueryParam.TRACK_CARRIER:
      return 'Carrier';
    case DropdownQueryParam.TRACK_SHIPPER:
      return 'Shipper';
    case DropdownQueryParam.TRACK_LOAD_FLAG:
      return 'Show only';
    case DropdownQueryParam.OPERATIONAL_ISSUE_TAG:
      return 'Tag';
    case DropdownQueryParam.OPERATIONAL_ISSUE_SEVERITY:
      return 'Severity';
    default:
      throw new Error('Invalid query param');
  }
};
